import { createDefaultVendorPayoffsData, IVendorPayoffsData } from '../../../types/vendorDashboard/IVendorPayoffs';
import {
  createDefaultSearchOrdersSettingsData,
  ISearchOrdersSettingsData,
} from '../../../types/vendorDashboard/ISearchOrdersSettingsData';
import { createDefaultFetch, IFetchStatus } from 'types/rest/IFetchStatus';

export interface IVendorPayoffsState {
  payoffs: IVendorPayoffsData;
  searchSettings: ISearchOrdersSettingsData;
  payoffsFetchStatus: IFetchStatus;
  payoffsError?: string;
}

export const vendorPayoffsInitialState: IVendorPayoffsState = {
  payoffs: createDefaultVendorPayoffsData(),
  searchSettings: createDefaultSearchOrdersSettingsData(),
  payoffsFetchStatus: createDefaultFetch(),
};
